import {
	differenceInDays,
	differenceInMonths,
	format,
	intervalToDuration,
} from "date-fns"
import { z } from "zod"

const timeSchema = z.union([
	// Схема для 24-часового формата (например, "23:59")
	z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/),
	// Схема для 12-часового формата (например, "11:59 PM")
	z.string().regex(/^(0?[1-9]|1[0-2]):[0-5][0-9]\s*(AM|PM|am|pm)$/),
])

type TimeString = z.infer<typeof timeSchema>

export function timeToMinutes(time: TimeString): number {
	time = time.toUpperCase()

	const isPM = time.includes("PM")
	const isAM = time.includes("AM")

	time = time.replace(/AM|PM/i, "").trim()

	const [hours, minutes] = time.split(":").map(Number) as [number, number]

	let totalMinutes = minutes

	if (isPM) {
		totalMinutes += (hours === 12 ? 12 : hours + 12) * 60
	} else if (isAM) {
		totalMinutes += (hours === 12 ? 0 : hours) * 60
	} else {
		totalMinutes += hours * 60
	}

	return totalMinutes
}

/**
 * Calculates the difference between two times
 * @param time1 First time in 24-hour ("HH:mm") or 12-hour ("HH:mm AM/PM") format
 * @param time2 Second time in 24-hour ("HH:mm") or 12-hour ("HH:mm AM/PM") format
 * @returns The difference in MINUTES between the two times. Returns -1 if input is invalid.
 */
export function getTimeDifference(time1: string, time2: string): number {
	try {
		const validTime1 = timeSchema.parse(time1)
		const validTime2 = timeSchema.parse(time2)

		const minutes1 = timeToMinutes(validTime1)
		const minutes2 = timeToMinutes(validTime2)

		if (minutes1 > minutes2) {
			return 24 * 60 - (minutes1 - minutes2)
		}
		return Math.abs(minutes1 - minutes2)
	} catch (error) {
		if (error instanceof z.ZodError) {
			console.error("Validation error:", error.errors)
		} else {
			console.error("Error:", error)
		}
		return -1
	}
}
